import React, { useContext, useState, useEffect } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, Form } from "react-bootstrap";
import { SelectState } from "../Controls";
import validator from "validator";

const PropertyLocation: React.FunctionComponent<{
  onSubmit?: (value: { city: string; state: string }) => void;
}> = (props: {
  onSubmit?: (value: { city: string; state: string }) => void;
}) => {
  const loanFormContext = useContext(LoanFormContext);
  const [city, setCity] = useState<InputType>({
    value: loanFormContext.propertyLocation?.city || "",
  });
  const [state, setState] = useState<InputType>({
    value: loanFormContext.propertyLocation?.state || "",
  });

  useEffect(() => {
    if (validator.isEmpty(city.value)) {
      setCity({ ...city, error: "City is required." });
    } else if (city.value.length < 3 || city.value.length > 24) {
      setCity({ ...city, error: "Enter a valid city name." });
    } else {
      setCity({ ...city, error: "" });
    }
  }, [city.value, setCity]);

  useEffect(() => {
    if (validator.isEmpty(state.value)) {
      setState({ ...state, error: "State is required." });
    } else if (state.value.length < 3 || state.value.length > 24) {
      setState({ ...state, error: "Enter a valid state name." });
    } else {
      setState({ ...state, error: "" });
    }
  }, [state.value, setState]);

  const handleSubmit = () => {
    if (!city.error && !state.error) {
      if (props.onSubmit) {
        props.onSubmit({ city: city.value, state: state.value });
      }
    } else {
      setState({ ...state, touched: true });
      setCity({ ...city, touched: true });
    }
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            In what city will the property be located?
          </h1>
        }
      >
        <div className="form-inputs-wrapper">
          <Form.Group>
            {/* <SelectCity onChange={handleSubmit} value={value.value} />
            {!error && (
              <div className="hint">
                (If your city is not listed, please try another close-by city)
              </div>
            )} */}
            <Form.Control
              type="text"
              placeholder="City"
              value={city.value}
              onBlur={() => {
                setCity({ ...city, touched: true });
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCity({ ...city, value: e.target.value })
              }
            />
            {city.error && city.touched && (
              <div className="hint text-danger">{city.error}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-5">
            <SelectState
              value={state.value}
              onChange={(v) => {
                setState({ ...state, value: v.value });
              }}
            />
            {state.error && state.touched && (
              <div className="hint text-danger">{state.error}</div>
            )}
          </Form.Group>
          <Form.Group>
            <Button
              variant="primary"
              block
              onClick={() => {
                handleSubmit();
              }}
            >
              Continue
            </Button>
          </Form.Group>
        </div>
      </FormStep>
    </div>
  );
};

interface InputType {
  value: string;
  error?: string;
  touched?: boolean;
}

export default PropertyLocation;
